import InlineSvg, { InlineSvgIds } from 'approot/shared/inline-svg/inline-svg';
import * as Styled from './component-tag.style';

const ComponentTag = ({
  iconId,
  name,
}: {
  iconId: InlineSvgIds;
  name: string;
}) => {
  return (
    <Styled.ComponentTag data-selector="component-tag">
      <InlineSvg id={iconId} width={12} height={12} />
      <span>{name}</span>
    </Styled.ComponentTag>
  );
};

export default ComponentTag;
